import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { logout } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem("token");
        const refreshToken = localStorage.getItem("refresh_token");

        if (!token) {
          if (!refreshToken) {
            logout();
            setIsAuthenticated(false);
            return;
          }

          try {
            const response = await fetch("/api/auth/refresh", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ refresh_token: refreshToken }),
            });

            if (!response.ok) {
              logout();
              setIsAuthenticated(false);
              return;
            }

            const data = await response.json();
            if (!data?.access_token) {
              logout();
              setIsAuthenticated(false);
              return;
            }

            localStorage.setItem("token", data.access_token);
            setIsAuthenticated(true);
          } catch {
            logout();
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(true);
        }
      } catch {
        logout();
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) return null;

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
